import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getToken, clearToken, apiFetch } from "./api";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SubscriptionsPage } from "./pages/SubscriptionsPage";
import { AdminLayout } from "./components/AdminLayout";
import "./index.css";

export function App() {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "/";

  if (pathname === "/login") {
    if (getToken()) {
      window.location.href = "/";
      return null;
    }
    return <LoginPage />;
  }

  if (!getToken()) {
    window.location.href = "/login";
    return null;
  }

  return (
    <AdminGate>
      <AdminLayout>
        {pathname === "/" || pathname === "/dashboard" ? (
          <DashboardPage />
        ) : pathname === "/users" ? (
          <UsersPage />
        ) : pathname === "/subscriptions" ? (
          <SubscriptionsPage />
        ) : pathname === "/settings" ? (
          <SettingsPage />
        ) : (
          <DashboardPage />
        )}
      </AdminLayout>
    </AdminGate>
  );
}

function AdminGate({ children }: { children: React.ReactNode }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["admin", "me"],
    queryFn: () => apiFetch<{ user: { is_admin?: boolean } }>("/api/auth/me"),
    retry: false,
  });

  if (isLoading) {
    return (
      <div className="auth-page">
        <p className="admin-muted">Checking access…</p>
      </div>
    );
  }

  if (error || !data?.user?.is_admin) {
    clearToken();
    return (
      <div className="auth-page">
        <div className="auth-form">
          <h1>Access denied</h1>
          <p className="auth-subtitle">Admin access only.</p>
          <a href="/login" className="btn btn-primary">Back to login</a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export default App;
